import clsx from 'clsx';
import { CSSProperties, FC, HTMLProps } from 'react';
import { useThemeColorPalette } from '../../hooks/use-theme-color-palette';
import { ThemeColors } from '../../theme';
import classes from './radio-input.module.scss';

export type RadioInputProps = Omit<HTMLProps<HTMLInputElement>, 'color'> & {
  color?: ThemeColors;
  error?: boolean;
};

export const RadioInput: FC<RadioInputProps> = ({ color, error, ...props }) => {
  const colorPalette = useThemeColorPalette(color ?? null);

  return (
    <input
      type="radio"
      {...props}
      style={{
        '--radio--color--main': colorPalette?.main,
        '--radio--color--dark': colorPalette?.dark,
        '--radio--color--contrast': colorPalette?.contrast,
        '--radio--color--ultra-light': colorPalette?.['ultra-light'],
        ...props.style
      } as CSSProperties}
      className={clsx(classes.root, 'radio-card-input-component', {
        [classes.disabled]: props.disabled,
        [classes.active]: props.checked,
        [classes.error]: error,
      })}
    />
  );
};
